module.exports = __webpack_public_path__ + "static/webbottom_bg.5ec5aebd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/webbottom_bg.jpg
// module id = 3225
// module chunks = 213231404188204